import styled from 'styled-components'

interface PredictionPassedMarkDesktopProps {
  topPercent: number
}

const PredictionPassedMarkDesktop = ({
  topPercent,
}: PredictionPassedMarkDesktopProps) => {
  const isPassed = topPercent <= 30

  return (
    <StyledWrapper data-is-passed={isPassed}>
      <strong>
        {isPassed ? (
          <>
            합격
            <br />
            예상
          </>
        ) : (
          <>
            불합격
            <br />
            예상
          </>
        )}
      </strong>
      <p>상위 {topPercent}%</p>
    </StyledWrapper>
  )
}

export default PredictionPassedMarkDesktop

const StyledWrapper = styled.div`
  width: 128px;
  height: 128px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: solid 3px #ef2929;

  > strong {
    font-size: 32px;
    font-weight: bold;
    line-height: 1.31;
    letter-spacing: -1.28px;
    text-align: center;
    color: #ef2929;
  }

  > p {
    font-size: 15px;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: -0.6px;
    color: #ef2929;
  }

  &[data-is-passed='true'] {
    border: solid 3px #004eff;

    > strong {
      color: #004eff;
    }

    > p {
      color: #004eff;
    }
  }
`
